import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const PlanningView = () => {
  const { id } = useParams();

  const [receiveData, setReceiveData] = useState(null);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Http.get(`/planning-detail/${id}`);
      console.log(response)
      setReceiveData(response.data);
    } catch (error) {
      console.log(error,'error')
      Swal.fire("Error!", "Failed to fetch planning details.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const showAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => setAlert(null), 4000);
  };

  if (loading || !receiveData) {
    return <LoaderComponent />;
  }

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Planning Report</h5>
        </div>
        <div className="am-pagebody">
          <Alert alert={alert} />
          <div className="card pd-20 pd-sm-40">
            <div className="text-center">
              <img
                src="https://artisan.projectsample.info/backend/public/image/artisan-logo.jpeg"
                width="20%"
              />
            </div>

            {/* General Work Order Details */}
            <div className="mb-3">
              <p>
                <strong>Receipt No:</strong> {receiveData.info.receipt_no}
              </p>
              <p>
                <strong>Start Date:</strong> {receiveData.info.start_date}
              </p>
              <p>
                <strong>End Date:</strong> {receiveData.info.end_date}
              </p>
            </div>

            {/* Work Order Details with Products & Sets */}
            {receiveData.list.map((wo, index) => (
              <div key={index} className="mb-4">
                <h6>
                  Work Order: {wo.company} <b>#{wo.receipt_no}</b>
                </h6>
                <div className="table-responsive p-0 pb-2">
                  <table className="table table-sm table-bordered table-striped align-items-center mb-0 _datatable">
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Item Name</th>
                        <th>Department</th>
                        <th>Shape</th>
                        <th>Glaze Colour</th>
                        <th>Decoration Name </th>
                        <th>Decoration Code</th>
                        <th>Order Qty</th>
                        <th>Qty</th>
                        {/* <th>Previous Production Qty</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {wo.products.map((item, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{item.product}</td>
                          <td>{item.department_art || "N/A"}</td>
                          <td>{item.shape || "N/A"}</td>
                          <td>{item.glaze_color || "N/A"}</td>
                          <td>{item.decoration || "N/A"}</td>
                          <td>{item.decoration_code || "N/A"}</td>
                          <td>{item.order_qty || "N/A"}</td>
                          <td>{item.qty}</td>
                          {/* <td>{item.previous_production_qty}</td> */}
                        </tr>
                      ))}
                      {/* Show sets if available */}
                      {wo.sets.length > 0 && (
                        <>
                          <tr>
                            <td colSpan="7" className="bg-light font-weight-bold">
                              Sets
                            </td>
                          </tr>
                          {wo.sets.map((set, sIdx) => (
                            <React.Fragment key={sIdx}>
                              <tr>
                                <td colSpan="7">
                                  <strong>Set #{set.set_id}</strong> | Input Qty:{" "}
                                  {set.input_qty} 
                                </td>
                              </tr>
                              {set.products.map((p, pIdx) => (
                                <tr key={pIdx}>
                                  <td>{`${sIdx + 1}.${pIdx + 1}`}</td>
                                  <td>{p.product}</td>
                                  <td>{p?.department_art || "N/A"}</td>
                                  <td>{p.shape || "N/A"}</td>
                                  <td>{p.glaze_color || "N/A"}</td>
                                  <td>{p.decoration || "N/A"}</td>
                                  <td>{p.decoration_code || "N/A"}</td>
                                </tr>
                              ))}
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanningView;
